export enum OutletLabelCategoriesEnum {
  NFP = 'NFP',
  MILL = 'Mühle',
  BIG_TIN = 'gr. Dose',
  SMALL_TIN = 'kl. Dose',
  XL_TIN = 'XL-Dose',
  XL_NFP = 'XL-NFP',
  XS = 'XS',
  NON_PACKING = 'Fremdmarke'
}
